<template>
  <div>
    <PageTitle :breadcrumbName="breadcrumbName" :pageTitle="pageTitle" class="mb-2"/>

    <div class="card columns gap2 mb-1">
      <div class="span-12">
        <h5 class="mb-1">PROCESSOS DE IMPORTAÇÃO</h5>
        <p class="text-light text-sm">Quantidade de Processos de Importação do Filtro:
          <strong>{{ processes.length }} processos</strong></p>
      </div>

      <div class="span-12 flex ai-c fgap2 fw-w">
        <div>
            <Select :value="filtroTipoProcesso.value" :options="tiposDoProcesso" title="Tipo de Processo" @input="changeFiltroTipoProcesso"/>
        </div>
        <div>
          <Select
            v-model="selectedCompaniesIds"
            :multiple="true"
            :classLi="'blured-select-list'"
            :options="userCompanies"
            title="Empresas"
          />
        </div>
        <div>
          <Select v-model="tipoFiltro" :options="tiposFiltro" title="Tipo de Filtro"/>
        </div>
        <div v-if="tipoFiltro === 'porEtapa'">
          <Select :value="filtroEtapa.value" :options="generateSteps" :useIcon="true" title="Etapas" @input="changeFiltroEtapa">
            <template #icon>
              <MapBoxIcon/>
            </template>
          </Select>
        </div>
        <template v-if="tipoFiltro === 'porPeriodo'">
          <div>
            <Select v-model="filtroCampo" :options="listOfDatesFields" :useIcon="true"
                    title="Tipo de Data">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div>
            <Select v-model="dataInicio" :useDate="true" :useIcon="true" title="Data Inicial">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div>
            <Select v-model="dataFim" :useDate="true" :useIcon="true" title="Data Final">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
        </template>
        <div class="flex ai-c fgap2 fw-w">
          <div>
            <a v-if="canClearFilters()" class="btn solid danger full-width" href="#"
               @click.prevent="clearFilters()">LIMPAR</a>
          </div>
          <div>
            <a class="btn solid primary full-width" href="#"
               @click.prevent="() => tipoFiltro === 'porEtapa' ? submitSearchStep() : submitSearchPeriod()">GERAR</a>
          </div>
          <div>
            <download-excel v-if="processes.length > 0" :data="processes" :fields="fieldsExcel" class="btn solid success btn-exportar full-width" name="relatorio-processos-importacao.xls" style="white-space: nowrap;">
                EXCEL
            </download-excel>
          </div>
        </div>
      </div>

      <div
        v-if="isEtapaConcluido && tipoFiltro === 'porEtapa'"
        class="span-12 concluido-period-hint medium-border-radius light-bordered offwhite-bg p-2 flex fd-c fgap2"
      >
        <div>
          <p class="text-medium text-sm mb-1">Filtro por período — obrigatório para processos concluídos</p>
          <p class="text-light text-sm">
            Selecione <strong>qual data</strong> deseja filtrar (ex.: Abertura, ETA, Desembaraço)
            e informe o <strong>período inicial e final</strong> antes de clicar em Gerar.
          </p>
        </div>
        <div class="flex ai-c fgap2 fw-w">
          <div>
            <Select
              v-model="filtroCampo"
              :options="listOfDatesFields"
              :useIcon="true"
              title="Tipo de Data *"
            >
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div>
            <Select v-model="dataInicio" :useDate="true" :useIcon="true" title="Data Inicial *" class="data-picker">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
          <div>
            <Select v-model="dataFim" :useDate="true" :useIcon="true" title="Data Final *" class="data-picker">
              <template #icon>
                <CalendarIcon/>
              </template>
            </Select>
          </div>
        </div>
      </div>
      <!--
            <div class="span-6 flex fw-w ai-c fgap2">

            </div> -->
    </div>

    <div class="card columns gap2 mb-2">
      <div class="span-12">
        <GoodTable
          :columns="tableColumns"
          :pagination="true"
          :rows="processes"
          :search="true"
          className="vgt-table center text-sm text-table text-medium sm-pd auto-width"
          @rowClick="openProcess"
        />
      </div>
    </div>

    <ModalProcess
      :data="modalData"
      :handler="modalProcessOpen"
      @request-close="() => {
        reminderOpen = false
        modalProcessOpen = false
      }"
    />

  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import { PROCESSOS_MODULE_PERMISSION_CODE } from '@/constants/portalPermissions';
import { resolveCompaniesIdsForApi } from '@/utils/portalPermissionAccess';

import {
  MapBoxIcon,
  CalendarIcon,
} from '@/components/Icons';
import PageTitle from '@/components/PageTitle.vue';
import Select from '@/components/DataInput/Select.vue';
// import Table from '@/components/Table.vue';
import ModalProcess from '@/components/ModalProcess.vue';
import GoodTable from '@/components/GoodTable.vue';

import * as labelsOfImportProcess from '@/utils/DateLabelsUtil';
import tableColumns from '@/utils/ProcessTableColumns';
import ProcessesReportColumnsExcel from '@/utils/ProcessesReportColumnsExcel';

export default {
  name: 'Home',
  components: {
    // Icons
    MapBoxIcon,
    CalendarIcon,
    // Components
    PageTitle,
    Select,
    GoodTable,
    ModalProcess,
  },
  data() {
    return {
      modalProcessOpen: false,
      filtroEtapa: { label: 'Todas', value: 8 },
      filtroTipoProcesso: { label: 'Todos', value: 'todos' },
      filtroCampo: '',
      dataInicio: '',
      dataFim: '',
      tipoFiltro: 'porEtapa',
      tiposFiltro: [
        {
          label: 'Por Etapa',
          value: 'porEtapa',
        },
        {
          label: 'Por Período',
          value: 'porPeriodo',
        },
      ],
      tiposDoProcesso: [
        {
          label: 'Todos',
          value: 'todos',
        },
        {
          label: 'Conta e Ordem',
          value: 'CONTA_E_ORDEM',
        },
        {
          label: 'Assessoria',
          value: 'ASSESSORIA',
        },
      ],
      modalData: {},
      labels: {
        id: {
          label: 'ID',
        },
        ...labelsOfImportProcess.labels[0],
      },
      columns: tableColumns,
      fieldsExcel: ProcessesReportColumnsExcel,
      selectedCompaniesIds: [],
    };
  },
  methods: {
    ...mapActions(
      'process',
      [
        'getSteps',
        'getProcesses',
        'getProcess',
        'updateProcesses',
        'updateIsSearchProccesses',
        'updatePendingFiltroEtapa',
        'updatePendingSelectedCompaniesIds',
        'getProcessDocuments',
        'getProcessInvoices',
        'getProcessFreightQuotationsResponses',
      ],
    ),
    ...mapActions(['toggleLoading']),
    getSelectedCustomersIds() {
      return resolveCompaniesIdsForApi(
        this.permittedCustomerCompaniesForModule(PROCESSOS_MODULE_PERMISSION_CODE),
        this.selectedCompaniesIds,
      );
    },
    buildProcessFilterParams(extra = {}) {
      const params = {
        ...extra,
        typeProcess: this.filtroTipoProcesso.value,
        customersIds: this.getSelectedCustomersIds(),
      };

      return params;
    },
    async openProcess(process) {
      const ok = await this.getProcess({ identification: process.id });
      if (ok) {
        this.modalData = this.process;
        this.modalData.documents = await this.getProcessDocuments(process.id);
        this.modalData.invoices = await this.getProcessInvoices(process.id);
        this.modalData.freightQuotationsResponses = await this.getProcessFreightQuotationsResponses(process.id);
        this.modalProcessOpen = true;
      }
    },
    async getProcessByRouteParams() {
      if (this.$route.params.id) {
        await this.getProcess({ identification: this.$route.params.id });
        this.modalData = this.process;
        this.modalData.documents = await this.getProcessDocuments(this.$route.params.id);
        this.modalData.invoices = await this.getProcessInvoices(this.$route.params.id);
        this.modalData.freightQuotationsResponses = await this.getProcessFreightQuotationsResponses(this.$route.params.id);
        this.modalProcessOpen = true;
      }
    },
    submitSearchStep() {
      if (this.isEtapaConcluido) {
        if (this.filtroCampo !== '' && this.dataInicio !== '' && this.dataFim !== '') {
          this.getProcesses(this.buildProcessFilterParams({
            stepId: 6,
            field: this.filtroCampo,
            from: this.dataInicio,
            to: this.dataFim,
          }));
        } else {
          this.showDateValidationAlert();
        }
        return;
      }
      this.clearPeriodFilter();
      this.getProcesses(this.buildProcessFilterParams({ stepId: this.filtroEtapa.value }));
    },
    showDateValidationAlert() {
      let html = '<div class="text-left pl-4 pr-4 pt-1"><p style="margin-bottom: 20px;">Por favor, preencha os campos abaixo!</p>';
      html += '<ul style="list-style-type: disc; margin-left: 30px;">';
      if (this.filtroCampo === '') {
        html += '<li class="mb-1">Tipo de data é obrigatório.</li>';
      }
      if (this.dataInicio === '') {
        html += '<li class="mb-1">Data inicial é obrigatória.</li>';
      }
      if (this.dataFim === '') {
        html += '<li class="mb-1">Data final é obrigatória.</li>';
      }
      html += '</ul></div>';
      this.$swal.fire({
        title: 'Campo Vazio',
        html,
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonColor: 'var(--primary-color)',
      });
    },
    submitSearchPeriod() {
      this.filtroEtapa.value = 8;
      this.getProcesses(this.buildProcessFilterParams({
        field: this.filtroCampo,
        from: this.dataInicio,
        to: this.dataFim,
      }));
    },
    canClearFilters() {
      return this.filtroEtapa.value !== 8
        || this.filtroTipoProcesso.value !== 'todos'
        || this.tipoFiltro !== 'porEtapa'
        || this.filtroCampo !== ''
        || this.dataInicio !== ''
        || this.dataFim !== ''
        || this.selectedCompaniesIds.length > 0;
    },
    clearFilters() {
      this.tipoFiltro = 'porEtapa';
      this.filtroEtapa = { label: 'Todas', value: 8 };
      this.filtroTipoProcesso = { label: 'Todos', value: 'todos' };
      this.selectedCompaniesIds = [];
      this.clearPeriodFilter();
      this.getProcesses(this.buildProcessFilterParams({ stepId: this.filtroEtapa.value }));
    },
    clearPeriodFilter() {
      this.filtroCampo = '';
      this.dataInicio = '';
      this.dataFim = '';
    },
    changeFiltroEtapa(value) {
      const val = this.steps.find((step) => step.id === value);
      if (val) {
        this.filtroEtapa = { label: val.description, value: val.id };
        if (val.id !== 6) {
          this.clearPeriodFilter();
        }
      }
    },
    changeFiltroTipoProcesso(value) {
      this.filtroTipoProcesso = { label: value, value: value };
    },
  },
  computed: {
    ...mapState('process', [
      'steps',
      'processes',
      'isSearchedProcesses',
      'pendingFiltroEtapa',
      'pendingSelectedCompaniesIds',
      'process',
    ]),
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['permittedCustomerCompaniesForModule']),
    userCompanies() {
      const customerCompanies = this.permittedCustomerCompaniesForModule(PROCESSOS_MODULE_PERMISSION_CODE)
        .map((company) => ({
          label: company.name.toUpperCase(),
          value: company.id,
        }));

      return [
        { label: 'TODAS', value: '' },
        ...customerCompanies,
      ];
    },
    tableColumns() {
      const stepId = this.filtroEtapa && this.filtroEtapa.value !== undefined ? this.filtroEtapa.value : 8;
      return this.columns[stepId] || this.columns[8] || [];
    },
    isEtapaConcluido() {
      return this.filtroEtapa.value === 6;
    },
    generateSteps() {
      return this.steps.filter((step) => step.id !== 9).map((step) => (
        { label: step.description, value: step.id }
      ));
    },
    listOfDatesFields() {
      const data = new Array(0);
      if (this.labels !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
        for (const prop in this.labels) {
          if (this.labels[prop].type === 'date') {
            data.push(this.labels[prop]);
          }
        }
      }
      return data;
    },
  },
  async created() {
    await this.getSteps();

    if (this.pendingSelectedCompaniesIds.length > 0) {
      this.selectedCompaniesIds = [...this.pendingSelectedCompaniesIds];
      this.updatePendingSelectedCompaniesIds([]);
    }

    if (this.pendingFiltroEtapa === 6) {
      this.changeFiltroEtapa(6);
      this.updatePendingFiltroEtapa(null);
    } else if (!this.isSearchedProcesses) {
      await this.getProcesses(this.buildProcessFilterParams({ stepId: this.filtroEtapa.value }));
    }

    this.toggleLoading(false);

    await this.getProcessByRouteParams();
  },
  destroyed() {
    this.updateProcesses([]);
    this.updateIsSearchProccesses(false);
  },
  mounted() {
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    breadcrumbName: {
      type: String,
      default: '',
    },
  },
};
</script>


<style scoped>
.concluido-period-hint {
  border-left: 4px solid var(--primary-color);
}

/* .data-picker ::v-deep .mx-datepicker {
  width: 100px !important;
} */

.data-picker ::v-deep .mx-input,
.data-picker ::v-deep .select-list.date input {
  background-color: transparent !important;
  background: transparent !important;
}
</style>
